/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmPackageDetails" />
/* tslint:disable:no-require-imports */
import * as VSS_Common_Contracts from "VSS/Platform/Contracts/WebApi";

import * as Contracts from "Feed/Common/Protocols/Npm/Contracts/Npm";

export class PackageVersionDetails implements Contracts.PackageVersionDetails {
    public deprecateMessage: string;
    public views: VSS_Common_Contracts.JsonPatchOperation;
    constructor(deprecateMessage?: string, viewToAdd?: string) {
        this.deprecateMessage = deprecateMessage;
        const patchDocument: VSS_Common_Contracts.JsonPatchOperation = {
            from: null,
            op: VSS_Common_Contracts.Operation.Add,
            path: "/views/-",
            value: viewToAdd
        };
        this.views = patchDocument;
    }
}
